/**
 * LegacyBriefLinkNotice
 *
 * Static notice shown at the retired ``/brief/:shareToken`` route.
 * The photographer flow now uses magic-link emails; any old bookmark
 * lands here instead of 404ing.
 */

import React from "react";
import { LinkIcon } from "@/components/icons";

export const LegacyBriefLinkNotice: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white border border-gray-200 rounded-lg shadow-xs p-6 text-center">
        <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-sky-50 text-sky-600 flex items-center justify-center">
          <LinkIcon className="w-6 h-6" />
        </div>
        <h1 className="text-lg font-semibold text-gray-900 mb-2">
          Link non piu valido
        </h1>
        <p className="text-sm text-gray-600">
          Il formato del link per i fotografi e cambiato. Chiedi allo staff
          di generare un nuovo link magico per accedere al brief.
        </p>
      </div>
    </div>
  );
};
